<div id="<%= dom_id region %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Code:</strong>
    <%= region.code %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Type:</strong>
    <%= region.type %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Location:</strong>
    <%= region.location %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Latitude:</strong>
    <%= region.latitude %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Longitude:</strong>
    <%= region.longitude %>
  </div>
</div>
